export default __webpack_public_path__ + "static/media/manage.7fdacd97.svg";